export enum ProjectChecklistType {
  GenericList,
  ProjectFiles
}
